enum DefaultColors {
  FIRST = "#0a0a0b",
  SECOND = "#e1e16c",
  THIRD = "#932020",
  FOURTH = "#1919b1",
  FIFTH = "#007400",
  SIXTH = "#9f3cb9",
  SEVENTH = "#3cc6c7",
  EIGHTH = "#5ec164",
  NINETH = "#caba8e",
  TENTH = "#c68ad8",
}

const maxSavedCanvasStates = 5;

export { DefaultColors, maxSavedCanvasStates };
